import usePagination from "../usePagination";
import { useEffect, useState } from "react";
import { fetchAllEnrollments } from "../../service/AdminService/enrollmentService";
import { message } from "antd";

export const useEnrollmentTablaData = (
  viewType,
  userName,
  groupName,
  courseTitle,
  bundleName,
  startDate,
  endDate,
  search,
) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(search);

    useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => clearTimeout(timer);
  }, [search]);


  const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    handlePageChange,
    setCurrentPage,
  } = usePagination(0, 5);

  const getPaginatedData = async () => {
    setLoading(true);

    const params = {
      page: currentPage,
      pageSize,
      search: debouncedSearch,
      viewType,
      userName,
      groupName,
      courseTitle,
      bundleName,
      startDate,
      endDate,
    };

    const response = await fetchAllEnrollments(params);

    if (response.success) {
      setData(response?.data?.content || []);
      setTotal(response?.data?.totalElements || 0);
    } else {
      message.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    getPaginatedData();
  }, [
    currentPage,
    pageSize,
    debouncedSearch,
    viewType,
    userName,
    groupName,
    courseTitle,
    bundleName,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [
    debouncedSearch,
    viewType,
    userName,
    groupName,
    courseTitle,
    bundleName,
    startDate,
    endDate,
  ]);

  return {
    data,
    loading,
    paginationConfig,
    handlePageChange,
  };
};
